module.exports = __webpack_public_path__ + "static/media/CLOCKWISE.05749c73.svg";